import { ActionTile } from '../../../../components/ActionTile';
import { appConfiguration } from '../../../../configuration/appConfiguration';
import { useCustomIntl } from '../../../../i18n/i18n';
import { useNavigate } from 'react-router-dom';
import { ONBOARDING_ROUTE } from '../../../../routes/routes';
import { useState } from 'react';
import { AddCardDialog } from './AddCardDialog';

export const QuickActions = () => {
  const intl = useCustomIntl();
  const navigate = useNavigate();
  const [addCardDialogOpen, setAddCardDialogOpen] = useState(false);

  return (
    <div className="display-grid gap-10 grid-cols-1-xs grid-cols-2-sm grid-cols-3-md">
      <ActionTile
        data-testid="quick-actions-manage-your-cards"
        externalIcon={`${appConfiguration.appUrl}/icon_card.svg`}
        title={intl.formatMessage({
          id: 'overview.quickActions.manageCards.title',
        })}
        description={intl.formatMessage({
          id: 'overview.quickActions.manageCards.description',
        })}
        onClick={() => navigate(ONBOARDING_ROUTE)}
      />
      <ActionTile
        icon="plus"
        title={intl.formatMessage({
          id: 'overview.quickActions.addCard.title',
        })}
        description={intl.formatMessage({
          id: 'overview.quickActions.addCard.description',
        })}
        onClick={() => {
          setAddCardDialogOpen(true);
        }}
      />
      <AddCardDialog
        open={addCardDialogOpen}
        onClose={() => setAddCardDialogOpen(false)}
      />
    </div>
  );
};
